import { render, staticRenderFns } from "./UploadControl.vue?vue&type=template&id=cc2ec41a&scoped=true&"
import script from "./UploadControl.vue?vue&type=script&lang=js&"
export * from "./UploadControl.vue?vue&type=script&lang=js&"
import style0 from "./UploadControl.vue?vue&type=style&index=0&id=cc2ec41a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2ec41a",
  null
  
)

export default component.exports